module.exports = __webpack_public_path__ + "img/Library.21ce047c.png";